/* eslint-disable @typescript-eslint/no-unused-vars */
import {
    Box,
    FormControlLabel,
    Grid,
    SelectChangeEvent,
    Switch,
    TextField,
    Typography,
    useMediaQuery,
    useTheme,
    Button,
    Divider,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from '@mui/material';
import ReactInputMask from 'react-input-mask';
import { useParams } from 'react-router-dom';
import { IUser, NivelAcesso, SubNivelAcesso, PermissaoTipo } from '../../../services/api/users/UserServices';
import { VSelectCompany } from '../../shared';
import { NivelAcessoModal } from './NivelAcessoModal';
import { useAuthContext } from '../../../context';
import { IDamsList } from '../../../services/api/dams/DamServices';

type PermissaoAtualizacao = PermissaoTipo | 'toggle';

interface UserFormProps {
    data: IUser;
    handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handlePermission: (newValue: string) => void;
    error: boolean;
    passwordError: boolean;
    handleChangeSelect: (event: SelectChangeEvent) => void;
    handleOutsystemUserChange: (outsystem: boolean) => void;
    handleNivelAcessoChange: (
        categoria: keyof NivelAcesso,
        subCategoria: keyof SubNivelAcesso,
        permission: PermissaoAtualizacao,
        isChecked: boolean
    ) => void;
    isNivelAcessoModalOpen: boolean;
    onCloseNivelAcessoModal: () => void;
    onOpenNivelAcessoModal: () => void;
    isEmpresa: boolean | false;
    isMainUser: boolean | false;
    listDam: IDamsList[] | null;
    handleChangeBarragem: (event: SelectChangeEvent<string[]>) => void;
}

export const UserForm = ({
    handleChange,
    data,
    handlePermission,
    error,
    handleChangeSelect,
    passwordError,
    handleOutsystemUserChange,
    handleNivelAcessoChange,
    isNivelAcessoModalOpen,
    onCloseNivelAcessoModal,
    onOpenNivelAcessoModal,
    isEmpresa,
    listDam,
    handleChangeBarragem,
    isMainUser
}: UserFormProps) => {

    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));
    const { userData } = useAuthContext();
    const { id } = useParams();

    const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>, value: boolean) => {
        const { name } = event.target;
        let newPermissoesArray = data.permissoes.split(',').filter(p => p !== '');

        if (value) {
            if (name === 'remove') {
                newPermissoesArray = ['add', 'edit', 'remove'];
            } else if (name === 'edit') {
                if (!newPermissoesArray.includes('remove')) {
                    if (!newPermissoesArray.includes('edit')) newPermissoesArray.push('edit');
                    if (!newPermissoesArray.includes('add')) newPermissoesArray.push('add');
                }
            } else if (name === 'add') {
                if (!newPermissoesArray.includes('remove') && !newPermissoesArray.includes('edit')) {
                    if (!newPermissoesArray.includes('add')) newPermissoesArray.push('add');
                }
            }
        } else {
            if (name === 'remove') {
                newPermissoesArray = newPermissoesArray.filter(p => p !== 'remove' && p !== 'edit' && p !== 'add');
            } else if (name === 'edit') {
                if (newPermissoesArray.includes('remove')) {
                    newPermissoesArray = ['add', 'edit', 'remove'];
                } else {
                    newPermissoesArray = newPermissoesArray.filter(p => p !== 'edit');
                }
            } else if (name === 'add') {
                if (newPermissoesArray.includes('remove')) {
                    newPermissoesArray = ['add', 'edit', 'remove'];
                } else if (newPermissoesArray.includes('edit')) {
                    newPermissoesArray = ['add', 'edit'];
                } else {
                    newPermissoesArray = newPermissoesArray.filter(p => p !== 'add');
                }
            }
        }

        const finalPermissoes = Array.from(new Set(newPermissoesArray)).join(',');
        handlePermission(finalPermissoes);
    };

    const handleOutsystemUserSwitchChange = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
        handleOutsystemUserChange(checked);
    };

    return (
        <Box>
            <Grid container spacing={2}>
                {userData.nivel === 'adm' ?
                    <Grid item xs={smDown ? 12 : 6}>
                        <VSelectCompany handleChangeSelect={handleChangeSelect} initValue={data.id_empresa} />
                    </Grid>
                    : null
                }
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        onChange={handleChange}
                        label='Nome'
                        type='text'
                        fullWidth
                        name='nome'
                        value={data?.nome}
                        InputLabelProps={{ shrink: true }}
                        error={error && data.nome === ''}
                        helperText={error && data.nome === '' ? 'É necessário preencher este campo' : null}
                        required
                    />
                </Grid>
                {
                    id !== 'novo' && userData.nivel !== 'user' ?
                        <Grid item xs={6}>
                            <Box display={'flex'} flexDirection={'column'} alignItems={'center'}>
                                <Typography>Usuário ativo?</Typography>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            name="ativo"
                                            checked={data.ativo}
                                            onChange={handleChange}
                                        />
                                    }
                                    label={data.ativo ? 'Ativo' : 'Inativo'}
                                />
                            </Box>
                        </Grid>
                        : null
                }
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        onChange={handleChange}
                        label='Login'
                        type='text'
                        fullWidth
                        name='login'
                        value={data?.login}
                        InputLabelProps={{ shrink: true }}
                        error={error && data.login === ''}
                        helperText={error && data.login === '' ? 'É necessário preencher este campo' : null}
                        required
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        onChange={handleChange}
                        label='E-mail'
                        type='text'
                        fullWidth
                        name='email'
                        value={data?.email}
                        placeholder='email@exemplo.com'
                        InputLabelProps={{ shrink: true }}
                        error={error && data.email === ''}
                        helperText={error && data.email === '' ? 'É necessário preencher este campo' : null}
                        required
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        onChange={handleChange}
                        label='Matricula'
                        type='text'
                        fullWidth
                        name='register'
                        value={data?.register}
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <Box display={'flex'} flexDirection={'column'} alignItems={'center'}>
                        <Typography>Usuário Fora de sistema?</Typography>
                        <FormControlLabel
                            control={
                                <Switch
                                    name="isOutsystemUser"
                                    checked={data.outsystem || false}
                                    onChange={handleOutsystemUserSwitchChange}
                                />
                            }
                            label={data.outsystem ? 'Sim' : 'Não'}
                        />
                    </Box>
                </Grid>
                {id === 'novo' && !data.outsystem ?
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            onChange={handleChange}
                            label='Senha'
                            type='password'
                            fullWidth
                            name='senha'
                            value={data?.senha}
                            InputLabelProps={{ shrink: true }}
                            error={passwordError}
                            helperText={passwordError ? 'A senha deve conter ao menos 5 dígitos.' : null}
                            required
                        />
                    </Grid> : null
                }
                <Grid item xs={smDown ? 12 : 6}>
                    <ReactInputMask
                        mask={'(99)99999-9999'}
                        value={data?.mobile_phone}
                        onChange={handleChange}
                    >
                        {({ inputRef, ...restInputProps }: React.InputHTMLAttributes<HTMLInputElement> & { inputRef?: React.Ref<HTMLInputElement> }) => (
                            <TextField
                                inputRef={inputRef}
                                name="mobile_phone"
                                value={data?.mobile_phone}
                                onChange={handleChange}
                                label='Telefone'
                                type='text'
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                            />
                        )}
                    </ReactInputMask>
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        onChange={handleChange}
                        label='Ramal'
                        type='number'
                        fullWidth
                        name='ramal'
                        value={data?.ramal}
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        onChange={handleChange}
                        label='Setor'
                        type='text'
                        fullWidth
                        name='sector'
                        value={data?.sector}
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        onChange={handleChange}
                        label='Cargo'
                        type='text'
                        fullWidth
                        name='role'
                        value={data?.role}
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                {isEmpresa && listDam && !isMainUser && (
                    <Grid item xs={smDown ? 12 : 6}>
                        <FormControl fullWidth>
                            <InputLabel id='barragens'>Barragens visiveis</InputLabel>
                            <Select
                                labelId='barragens'
                                multiple
                                value={Array.isArray(data.barragens_visiveis) ? data.barragens_visiveis : []}
                                onChange={handleChangeBarragem}
                            >
                                {listDam.map(i =>
                                    <MenuItem key={i.uuid} value={i.uuid}>{i.nome}</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    </Grid>
                )}

                {/* <Grid item xs={12}>
                    <Box sx={{ mt: 2, mb: 1 }}>
                        <Typography variant='h6' sx={{ mb: 1 }}>Permissões Gerais do Usuário</Typography>
                        <Divider />
                    </Box>
                </Grid> */}
                {/* <Grid item xs={smDown ? 12 : 6}>
                    <Box display={'flex'} flexDirection={'column'} alignItems={'center'}>
                        <Typography color={theme.palette.text.primary}>Ações básicas do usuário</Typography>
                        <Box display={'flex'} flexDirection={'column'} justifyContent={'center'} alignContent={'center'} padding={1}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        name="add"
                                        checked={data.permissoes.includes('add')}
                                        onChange={(e, value) => handleSwitchChange(e, value)}
                                    />
                                }
                                label={'Salvar'}
                            />
                            <FormControlLabel
                                control={
                                    <Switch
                                        name="edit"
                                        checked={data.permissoes.includes('edit')}
                                        onChange={(e, value) => handleSwitchChange(e, value)}
                                    />
                                }
                                label={'Editar'}
                            />
                            <FormControlLabel
                                control={
                                    <Switch
                                        name="remove"
                                        checked={data.permissoes.includes('remove')}
                                        onChange={(e, value) => handleSwitchChange(e, value)}
                                    />
                                }
                                label={'Excluir'}
                            />
                        </Box>
                    </Box>
                </Grid> */}

                <Grid item xs={12}>
                    <Box sx={{ mt: 2, mb: 1 }}>
                        <Typography variant='h6' sx={{ mb: 1 }}>Permissões Detalhadas do Usuário</Typography>
                        <Divider />
                    </Box>
                </Grid>


                <Grid item xs={smDown ? 12 : 6}>
                    <Box display={'flex'} flexDirection={'column'} alignItems={'center'} height="100%" justifyContent="center">
                        <Typography color={theme.palette.text.primary} sx={{ mb: 1 }}>
                            Configurar Níveis de Acesso
                        </Typography>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={onOpenNivelAcessoModal}
                            sx={{ mt: 1 }}
                        >
                            Abrir Níveis de Acesso
                        </Button>
                    </Box>
                </Grid>
            </Grid>

            <NivelAcessoModal
                isOpen={isNivelAcessoModalOpen}
                onClose={onCloseNivelAcessoModal}
                currentNivelAcesso={data.nivel_acesso || {}}
                onUpdateNivelAcesso={handleNivelAcessoChange}
            />
        </Box>
    );
};